import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { Icon, Icons } from "../../Components/Icon"
import { INMEASource } from "../../Types"
import { GetNMEAConfigurationContext, NMEAConfigurationViewData, NMEADebugCaptureStatus } from "./Context"

export function NMEAConfigurationTestDataView() {
  const app = GetApp()!;
  const t = app.getT("NMEAConfigurationView");
  const { statusChecks, status, resetConnection, completedCallback } = GetNMEAConfigurationContext();
  const [captureStatus, setCaptureStatus] = useState<NMEADebugCaptureStatus>("idle");

  // #1113: uploads the last seconds of raw NMEA traffic the app received as a device
  // debug trace, so support can see what the instruments actually sent. Only
  // meaningful for a native session, which is the one holding the connection (hence
  // the `!app.cloudSession()` guard around the button below).
  const uploadDebugCapture = useCallback(async () => {
    if (captureStatus === "sending") {
      return;
    }
    setCaptureStatus("sending");
    try {
      await NMEAConfigurationViewData.uploadDebugCapture(app.apiClient);
      setCaptureStatus("success");
    } catch (_error) {
      setCaptureStatus("error");
    }
  }, [app, captureStatus]);

  return (
    <Block key="test_data">
      <div className="NMEAConfigurationView-checks">
        {Object.keys(statusChecks).map((key) => {
          const source = statusChecks[key]?.source;
          return (
            <div key={`data-${key}`} className="block-row">
              <Icon className={`status-${key.startsWith("native_") ? (source === INMEASource.native ? "nmea" : "error") : (source === INMEASource.nmea ? "nmea" : "error")}`} icon={Icons.CircleFilledLarge} /> {t("check_" + key)}
            </div>
          );
        })}
      </div>
      <BlockRow className="padding-top-large">
        {t("check_engine_ids", { ids: NMEAConfigurationViewData.engineIds(status?.data).join(", ") || t("check_engine_ids_none") })}
      </BlockRow>
      {!app.cloudSession() && (
        <>
          <hr></hr>
          <BlockRow className="NMEAConfigurationView-capture padding-top-large">
            <BlockField className="NMEAConfigurationView-capture-hint">
              {t("capture_hint")}
            </BlockField>
            <BlockField>
              <button
                type="button"
                className="button"
                disabled={captureStatus === "sending"}
                onClick={uploadDebugCapture}
              >
                {NMEAConfigurationViewData.debugCaptureLabel(captureStatus, t)}
              </button>
            </BlockField>
          </BlockRow>
        </>
      )}
      <BlockRow className="block-row-actions block-row-bottom">
        <BlockField>
          <button className="button" onClick={resetConnection}>{t("reset")}</button>
        </BlockField>
        <BlockField>
          <button className="button default" onClick={() => completedCallback()}>{t("complete")}</button>
        </BlockField>
      </BlockRow>
    </Block>
  );
}
